import React from 'react';
import { BaseModal } from 'src/design/molecules/BaseModal';
import { ApiConnectionDto } from 'src/api/FiretrolApiClient';
import { ApiConnectionForm } from './ApiConnectionForm';

interface ApiConnectionDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  connection: ApiConnectionDto | null;
}

export const ApiConnectionDialog: React.FC<ApiConnectionDialogProps> = ({
  open,
  onClose,
  onSave,
  connection,
}) => (
  <BaseModal
    opened={open}
    onClose={onClose}
    title={connection ? 'Update Connection' : 'Create New Connection'}
    size="lg"
    centered
  >
    <ApiConnectionForm
      onClose={onClose}
      onSave={onSave}
      connection={connection}
    />
  </BaseModal>
);
